import React from "react";

function SearchVectorColumnSelect({ value, onChange }) {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="searchVectorColumnSelect" className="form-label">
        Search Vector Column
      </label>
      <select className="form-select" id="searchVectorColumnSelect" value={value} onChange={handleChange}>
        <option value="text_embedding_3_large_256">text_embedding_3_large_256</option>
        <option value="text_embedding_3_large_1536">text_embedding_3_large_1536</option>
      </select>
    </div>
  );
}

export default SearchVectorColumnSelect;
